import { useMemo } from "react";

export const useWindowResolution = () => {
    const isMobile = useMemo(() => {
        return window.screen.width < 600;
    }, [window.screen]);
    return {
        isMobile,
    };
};
